import { SlotStatus } from "../web-api-client";

export const SLOT_STATUS_UI: Record<
  SlotStatus,
  {
    accent: string;
    background: string;
    textColor: string;
    label: string;
  }
> = {
  0: {
    accent: "bg-primary/70",
    background: "bg-white",
    textColor: "text-green-700",
    label: "Còn chỗ",
  },
  1: {
    accent: "bg-yellow-400",
    background: "bg-yellow-50",
    textColor: "text-yellow-700",
    label: "Sắp đầy",
  },
  2: {
    accent: "bg-red-400",
    background: "bg-red-50",
    textColor: "text-red-700",
    label: "Đầy",
  },
  3: {
    accent: "bg-gray-400",
    background: "bg-gray-200",
    textColor: "text-gray-600",
    label: "Kh",
  },
};
